import { staticAssetBasePath }  from 'utils/staticAssetBasePath';
 
// Base asset path. '../assets' for development and '/<platform>.assets' in case of production
const BASE_ASSET_PATH = staticAssetBasePath() ;

/*****************************/

// drug-search
export const IMAGE_GOOGLE_MAP = `${ BASE_ASSET_PATH }/images/content_images/google_map.png`;
